import React, { memo, useEffect, useState } from 'react';
import { GetContainersForExperimentInfo, showAlertSnackBar } from 'utils/Global';
import { useRMSelector } from 'redux/hooks';
import { selectGlobalDataLoaded } from 'redux/selectors/StateSelectors';
import {
  ExperimentScreenLot,
  IExperimentScreenLot,
  ResponseDTO,
  ResponseType,
} from 'business/models/Models';
import '../ExperimentInfo/ExperimentInfoDetails.scss';
import AddScreenLot from './AddScreenLot';
import LotsManager from './LotsManager';
import { setExpInfoIsDirty } from '../ImagingSchedule/ImagingScheduleData';
import {
  addScreenLot,
  deleteScreenLot,
  updateScreenLot,
} from 'redux/reducers/experimentDataReducer';
import { useDispatch } from 'react-redux';
import { cloneDeep } from 'lodash';
import getExperimentInfoDetails from '../ExperimentInfo/ExperimentInfo';
import EContainerType from 'enums/EContainerType';
import ScreenService from 'business/services/ScreenService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';

const ScreenLot = (props) => {
  const [containers, setContainers] = useState([]);
  const [selectedLot, setSelectedLot] = useState<IExperimentScreenLot>(null);
  const _selectGlobalDataLoaded = useRMSelector(selectGlobalDataLoaded);
  const expInfo = getExperimentInfoDetails();

  const dispatch = useDispatch();
  const _exp = useRMSelector((state) => state.experiment.expData);
  const exp = cloneDeep(_exp);

  const checkScreenLotInUse = async (screenLotId: number) => {
    const screenService = new ScreenService();
    const response: ResponseDTO = await screenService.checkScreenLotInUse(screenLotId);
    return response;
  };

  useEffect(() => {
    if (!expInfo.IsDirty && selectedLot?.id < 0) {
      setSelectedLot(null);
    }
  }, [exp]);

  useEffect(() => {
    const _containers = GetContainersForExperimentInfo(exp?.info?.containerId, [
      EContainerType.ScreenContainer,
    ]);
    if (!containers || containers.length === 0) {
      return;
    }
    setContainers(_containers);
  }, [_selectGlobalDataLoaded]);

  const addLot = (lot: ExperimentScreenLot) => {
    dispatch(addScreenLot(lot));
    setSelectedLot(null);
    setExpInfoIsDirty(true);
  };

  const updateLot = (lot: ExperimentScreenLot) => {
    dispatch(updateScreenLot(lot));
    setSelectedLot(null);
    setExpInfoIsDirty(true);
  };

  const deleteLot = async (lot: ExperimentScreenLot) => {
    const response = await checkScreenLotInUse(lot.id);
    if (response.responseType === ResponseType.Error) {
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
      return;
    }
    dispatch(deleteScreenLot(lot));
    setSelectedLot(null);
    setExpInfoIsDirty(true);
  };

  return (
    <>
      <div
        id={`screenlot-header`}
        className="font-bold text-[#F7A246] py-[15px] px-[10px] bg-[#E4E4E4]"
      >
        Screen Lots
      </div>
      <AddScreenLot
        expData={exp}
        selectedLot={selectedLot}
        addLot={addLot}
        updateLot={updateLot}
        setSelectedLot={setSelectedLot}
      />
      <LotsManager expData={exp} setSelectedLot={setSelectedLot} deleteLot={deleteLot} />
    </>
  );
};

export default memo(ScreenLot);
